module.exports = __webpack_public_path__ + "media/flowyo_2.9d7136f7.mp4";